/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Button, Card, Empty, Input, Pagination, Space, Switch, Table, Typography } from 'antd';

import { Link } from 'react-router-dom';

import { PlusOutlined } from '@ant-design/icons';
import api from '~/services/api';
import history from '~/services/history';
import { Container } from './styles';

export default function Item(props) {
  const [technicians, setTechnicians] = useState([]);
  const profile = useSelector(state => state.user.profile);

  // const [isFiltered, setIsFiltered] = useState(false);
  const [paginationSize, setPaginationSize] = useState(new URLSearchParams(props.location.search).get('size') || 25);
  const [paginationPage, setPaginationPage] = useState(new URLSearchParams(props.location.search).get('page') || 1);
  const [paginationTotalItems, setPaginationTotalItems] = useState();
  const [active, setActive] = useState(true);

  const searchTextRef = useRef('');

  const { Search } = Input;
  const { Title } = Typography;

  const handleSearch = useCallback(
    async value => {
      const response = await api.get(`technicians?size=${paginationSize}&page=${paginationPage - 1}`, {
        headers: {
          filterText: value?.trim() || searchTextRef.current.input.value || '',
          filterActive: active,
        },
      });
      if (response.data.error) {
        toast.warn('Technician has not been found!');
        return;
      }
      setPaginationTotalItems(response.data.totalItems);
      setPaginationSize(response.data.sizePage);
      setPaginationPage(response.data.currentPage + 1);
      setTechnicians(response.data.rows);
    },
    [active, paginationPage, paginationSize]
  );

  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    const { search } = props.location;
    const params = new URLSearchParams(search);
    const searchQuery = params.get('searchQuery');
    if (searchQuery) {
      searchTextRef.current.input.value = searchQuery;
      handleSearch();
    }
  }, []); //eslint-disable-line

  const handleChangePage = (page, pageSize) => {
    setPaginationPage(page);
    setPaginationSize(pageSize);
  }

  useEffect(() => {
    handleSearch();
  }, [handleSearch]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: text => (
        <Link to={`/techniciansNew?name=${text}&searchQuery=${searchTextRef.current.input.value}&size=${paginationSize}&page=${paginationPage}`}>{text}</Link>
      ),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
  ];

  return (
    <Container>
      <Card size="small" bordered={false}>
        {/* <h1>Technicians</h1> */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {profile.type === 3 || profile.type === 999 ? (
            <Button onClick={() => history.push('/techniciansNew')} variant="contained" type="primary" icon={<PlusOutlined />}>
              Add
            </Button>
          ) : (
            <div />
          )}
          <Title level={3}>Technicians</Title>
          <div />
        </div>
      </Card>
      <Card elevation={3} size="small">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Space wrap>
            <Search
              placeholder="Search Technicians's Name"
              ref={searchTextRef}
              allowClear
              onSearch={() => {
                handleSearch();
                // setPaginationPage(1);
              }}
              style={{ width: 300 }}
              enterButton
            />
          </Space>
          <Space wrap>
            {/* {isFiltered && (
              <Tag
                closable
                color="error"
                onClose={e => {
                  e.preventDefault();
                  handleClearFilters();
                }}
              >
                Clear Filters
              </Tag>
            )} */}
            {active ? <Title level={5}>Active Technicians</Title> : <Title level={5}>All Technicians</Title>}

            <Switch
              onChange={value => {
                setActive(value);
                // setPaginationPage(1);
                handleSearch();
              }}
              defaultChecked={active}
            />
          </Space>
        </div>
      </Card>

      {technicians.length <= 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>Use the search box above to list technicians</span>}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '60vh',
          }}
        />
      ) : (
        <>
          <Table
            style={{ marginTop: '5px' }}
            columns={columns}
            dataSource={technicians}
            size="small"
            bordered
            pagination={false}
            scroll={{ y: 'calc(100vh - 22em)' }}
            rowKey={record => record.id}
          />
          <Card size="small" bordered={false} style={{ marginTop: '5px' }}>
            <Pagination
              size="small"
              total={paginationTotalItems}
              showSizeChanger
              showQuickJumper
              defaultPageSize={paginationSize}
              pageSizeOptions={[25, 50, 100]}
              onChange={handleChangePage}
              current={paginationPage}
            />
          </Card>
        </>
      )}
    </Container>
  );
}
